import React, { useState, useEffect, useRef } from 'react';
import MediaQuery from 'react-responsive';
import { NavLink } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import './styles.css';

const NavDropdown = props => {
  const {
    isActive,
    children,
    item,
    item: { href, name, disabled },
    navClass,
    activeClassName,
    onClick,
    toggleIndex,
    toggledIndex,
    toggleFunc,
  } = props;

  const [showDropdown, setShowDropdown] = useState(false);

  const node = useRef();

  useEffect(() => {
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  });

  useEffect(() => {
    if (toggleIndex === toggledIndex && !showDropdown) {
      setShowDropdown(true);
    } else if (toggleIndex !== toggledIndex) {
      setShowDropdown(false);
    } else {
      setShowDropdown(!showDropdown);
    }
  }, [toggledIndex]);

  const selectedClass = showDropdown || isActive ? activeClassName : '';
  const chevron = showDropdown ? (
    <FontAwesomeIcon icon={faChevronUp} color="#fff" size="sm" />
  ) : (
    <FontAwesomeIcon icon={faChevronDown} color="#fff" size="sm" />
  );
  const subMenuStyles = {
    display: showDropdown ? 'flex' : 'none',
  };

  const childrenWithProps = React.Children.map(children, child => {
    if (child.type.name === 'NavDropdownSubmenu') {
      return React.cloneElement(child, { hoverOff: hoverOff });
    } else {
      return React.cloneElement(child);
    }
  });

  const hoverOn = () => {
    setShowDropdown(true);
  };

  const hoverOff = () => {
    setShowDropdown(false);
  };

  const onClickMobile = e => {
    e.preventDefault();
    setShowDropdown(!showDropdown);
    toggleFunc(toggleIndex);
  };

  const handleClick = e => {
    onClick(e, item);
  };

  const handleClickOutside = e => {
    const isOutsideClick = node.current
      ? !node.current.contains(e.target)
      : null;
    if (showDropdown && isOutsideClick) {
      setShowDropdown(false);
    }
    toggleFunc(null);
    setShowDropdown(false);
  };

  return (
    <>
      <MediaQuery query="(min-width: 1025px)">
        <div
          onMouseEnter={hoverOn}
          onMouseLeave={hoverOff}
          className={`navbar-dropdown ${navClass} ${selectedClass}`}
        >
          <NavLink
            exact
            to={disabled ? '#' : href}
            className="navbar-dropdown__text"
            activeClassName="navbar-dropdown__text--selected"
            onClick={handleClick}
          >
            {name}
            <span className="navbar-dropdown__icon">{chevron}</span>
          </NavLink>

          <div
            className="navbar-dropdown__submenu"
            ref={node}
            style={subMenuStyles}
          >
            {childrenWithProps}
          </div>
        </div>
      </MediaQuery>
      <MediaQuery query="(max-width: 1024px)">
        <div className={`navbar-dropdown ${navClass} ${selectedClass}`}>
          <NavLink
            exact
            to={disabled ? '#' : href}
            className="navbar-dropdown__text"
            activeClassName="navbar-dropdown__text--selected"
            onClick={onClickMobile}
          >
            {name}
            <span className="navbar-dropdown__icon">{chevron}</span>
          </NavLink>
          <div
            className="navbar-dropdown__submenu"
            ref={node}
            style={subMenuStyles}
          >
            {childrenWithProps}
          </div>
        </div>
      </MediaQuery>
    </>
  );
};

export default NavDropdown;
